import consistencyDo from "../../../../src/pages/foundations/iconography/_assets/consistency-do_2x.png";
import consistencyDont from "../../../../src/pages/foundations/iconography/_assets/consistency-dont_2x.png";
import simplifiedShapesDo from "../../../../src/pages/foundations/iconography/_assets/simplified-shapes-do_2x.png";
import simplifiedShapesDont from "../../../../src/pages/foundations/iconography/_assets/simplified-shapes-dont_2x.png";
import metaphorsDo from "../../../../src/pages/foundations/iconography/_assets/metaphors-do_2x.png";
import metaphorsDont from "../../../../src/pages/foundations/iconography/_assets/metaphors-dont_2x.png";
import perspectiveDo from "../../../../src/pages/foundations/iconography/_assets/perspective-do_2x.png";
import perspectiveDont from "../../../../src/pages/foundations/iconography/_assets/perspective-dont_2x.png";
import cornersDo from "../../../../src/pages/foundations/iconography/_assets/corners-do.png";
import cornersDont from "../../../../src/pages/foundations/iconography/_assets/corners-dont.png";
import endPointsDo from "../../../../src/pages/foundations/iconography/_assets/end-points-do.png";
import endPointsDont from "../../../../src/pages/foundations/iconography/_assets/end-points-dont.png";
import * as React from 'react';
export default {
  consistencyDo,
  consistencyDont,
  simplifiedShapesDo,
  simplifiedShapesDont,
  metaphorsDo,
  metaphorsDont,
  perspectiveDo,
  perspectiveDont,
  cornersDo,
  cornersDont,
  endPointsDo,
  endPointsDont,
  React
};